export default {"src":"/_next/static/media/payment-maestro.a4119538.svg","height":30,"width":44,"blurWidth":0,"blurHeight":0};